import $ from 'jquery';

window.$ = window.jQuery = $;
global.$ = global.jQuery = $;

require('./bootstrap')
require('owl.carousel')
require('./main')
